/**
 * Constants specific to the TopNavBar component.
 */
export const topNavBarHeight = 85;
